<template>
  <div class="content">
    <template >
      <div class="table-page-search-wrapper search-bt">
        <a-form layout="inline" :labelCol="{ style: { width: '90px' } }">
          <a-row>
            <a-col :md="6" :sm="24">
              <a-form-item label="月度计划名称">
                <global-select
                  disabled
                  :value.sync="queryParams.id"
                  selectType="selectSearch"
                  requestApi="/scp/sopMonthPlan/monthPlanNamePullDown"
                  :selectItem="{ value: 'realValue', label: 'label' }"
                  :setParams="{ monthPlanId: queryParams.id }"
                  searchParam="name"
                />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="版本">
                <global-select
                  disabled
                  :value.sync="queryParams.monthPlanVersion"
                  selectType="selectSearch"
                  requestApi="/scp/sopMonthPlan/monthPlanVersionPullDown"
                  :selectItem="{ value: 'realValue', label: 'label' }"
                  searchParam="version"
                />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <span class="table-page-search-submitButtons">
                <a-button @click="onSearch" type="primary" class="ml8">查询</a-button>
                <!--  <a-button @click="resetQuery" class="ml8">重置</a-button> -->
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
    </template>
    <template>
      <a-tabs class="content-tabs" type="card" @change="callback">
        <a-tab-pane key="1" tab="按类型">
          <type-table ref="TypeTable" :id="queryParams.id"></type-table>
        </a-tab-pane>
        <a-tab-pane key="2" tab="按期间">
          <period-table ref="PeriodTable" :id="queryParams.id"></period-table>
        </a-tab-pane>

      </a-tabs>
    </template>
  </div>
</template>
  <script>
    import PeriodTable from './components/PeriodTable'
    import TypeTable from './components/TypeTable'
  export default {
    // eslint-disable-next-line
    name: 'capacityLoadPage', // name要和菜单路由保存一致; 新页面不要建这种容易重复的name
    components: {
      PeriodTable,
      TypeTable
    },
    data () {
      return {
        timer: null,
        // 查询参数
        queryParams: {
          id: undefined,
          monthPlanName: undefined,
          monthPlanVersion: undefined
        }
      }
    },
    methods: {
      onSearch () {
       if (this.$refs.PeriodTable) {
        this.$refs.PeriodTable.onSearch()
       }
       if (this.$refs.TypeTable) {
        this.$refs.TypeTable.onSearch()
       }
      },
      handleVersionChange (val, list) {
        const filteredObject = list.filter(obj => obj.selectedValue === val);
          this.queryParams.versionCode = filteredObject[0].selectedValue
          this.queryParams.description = filteredObject[0].realValue
      },
      callback (key) {
        console.log(key)
      }
    },
      created () {
          this.queryParams.id = this.$route.params.id; // 从路由参数中获取 id 值
         // this.queryParams.versionCode = this.$route.params.version; // 从路由参数中获取 id 值
          this.queryParams.monthPlanName = this.$route.params.name; // 从路由参数中获取 id 值
          this.queryParams.monthPlanVersion = this.$route.params.version; // 从路由参数中获取 id 值
      },
      mounted () {
       // this.onSearch()
      }
  }
  </script>
  <style lang="less" scoped>
  .content{
      display: flex;
      flex-direction: column;
      width: 100%;
      height: 100%;
  }.search-bt{
      background-color: white;
      padding: 8px;
      margin-bottom: 8px;
  }.content-tabs{
      background-color: white;
      width: 100%;
      flex:1;
      padding: 8px;
  }.ml8{
    margin-left: 8px
  }
  </style>
